module.exports = __webpack_public_path__ + "static/media/lap.a906f154.png";